import { Component, OnChanges, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';

import { ManageCurriculumComponent } from '../manage-curriculum/manage-curriculum.component';
import { ManageCalendariComponent } from '../manage-calendar/manage-calendar.component';

import { NotesService } from './notes.service';
import { DialogNotes } from '../dialog/notes/dialog.component.notes';
import { DialogOportunitats } from '../dialog/oportunitats/dialog.component.oportunitats';
import { DialogDedicats } from '../dialog/dedicats/dialog.component.dedicats';
import { DialogManageInvoiceComponent } from '../dialog/manage-invoice/dialog.manage-invoice.component';
import { DialogDedicatsMes } from '../dialog/dedicats-mes/dialog.component.dedicats-mes';

import { MatDialog } from '@angular/material/dialog'

import { TokenStorageService } from '../services/auth-user-service/token-storage.service';

import { ListNotesService } from './list.service';
import { saveAs } from 'file-saver';

import { IFRNotes, IFRNota } from './notes.interfaces';
import { IFROportunitats } from '../oportunitats/oportunitats.interfaces';
import { IFRDedicats } from '../notes/dedicats.interfaces';

import { OportunitatsService } from '../oportunitats/oportunitats.service';
import { DedicatsService } from '../notes/dedicats.service';

import { StripHtmlPipe } from '../pipes/stripHTMLpipe';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'mcrit-gestio-notes',
  templateUrl: 'notes.component.html',
  styleUrls: ['notes.component.scss'],
  providers: [NotesService, DedicatsService, OportunitatsService, StripHtmlPipe]
})
export class NotesComponent implements OnInit {
   @Input('elementList') elementList: any;
   @Output('requestRows') requestRows = new EventEmitter();

   public showAsyncProgress: boolean = false;
   public notesData: IFRNotes = {oportunitats:[], manifestacions:[], propostes_neg:[], propostes_red:[], propostes_pre:[], projectes:[], gestions:[]};

   public activeFilters: any = {};
   private currentOrdering: any = {};
   private orderingCycle: Array<string> = ['', 'ASC', 'DESC'];
   public userInfo: any = {};
   private unsubscriber : Subject<void> = new Subject<void>();

   public showFilters: boolean = true;
   public orderingParameters: any;
   public export: boolean = false;
   public showDialog: boolean = false;
   public editNotesData: IFRNota;
   public editOportunitatsData: IFROportunitats;
   public filtrat: boolean = false;
   public rol: any = 0;
   public currentDate = "";
 
   private notesModel: IFRNota = {
      'id': 'NEW',
      'data': null,
      'observacions': null,
      'nota_e': null,
      'taula': null
   };
   public editDedicacionsData = Object.assign({});
   private DedicacionsModel: IFRDedicats = {
      'id': 'NEW',
      'personal_id': null,
      'descripcio': null,
      'hores': null,
      'inici': null,
      'fi': null,
      'percent': null,
      'codi': null,
      'tipus': null
   };

   public toggleFiltersVisibility() {
     this.showFilters = !this.showFilters;
   }

   public computeActiveFilters($event){
     this.activeFilters = $event;
     this.filtrat = Object.keys(this.activeFilters).length !== 0 && this.activeFilters.name != this.userInfo.name;
     this.requestRowsToParent();
   }

   public cycleOrdering(key) {
    let i = this.orderingParameters[key]?this.orderingParameters[key]:0;

    this.orderingParameters = {};
    this.orderingParameters[key] = (1 + i) % this.orderingCycle.length;

    this.currentOrdering = {};
    this.currentOrdering[key] = this.orderingCycle[this.orderingParameters[key]];

    this.requestRowsToParent();
  }

  private requestRowsToParent(): void {
    //Parxe per solucionar el tema que les Oportunitats no tenen el codi d'usuari i si el nom 220322
    if(!Object.keys(this.activeFilters).find(item => item == "name"))
          this.activeFilters.name = this.userInfo.name;    
    this.notesService.get(
       this.userInfo.id, 
       this.activeFilters //FILTRE DELS REGISTRES QUE ES MOSTREN A INICI
       ,{}//Conds a aplicar. Per defecte LIKE %%
       ,this.currentOrdering //ORDRE DELS TREBALLS QUE ES MOSTREN A INICI (tematica3, data_aprovacio)
    ).subscribe(
       data => {
          this.notesData["oportunitats"] = data["oportunitats"].rows;
          this.notesData["manifestacions"] = data["manifestacions"].rows;
          this.notesData["propostes_neg"] = data["propostes_neg"].rows;
          this.notesData["propostes_pre"] = data["propostes_pre"].rows;
          this.notesData["propostes_red"] = data["propostes_red"].rows;
          this.notesData["projectes"] = data["projectes"].rows;
          this.notesData["gestions"] = data["gestions"].rows;
       },
       error => console.log(error)
    );
  }

  public editNota(taula, codi, nota, data_nota, nota_e): void {
    this.editNotesData = Object.assign(this.notesModel);
    this.editNotesData.id = codi;
    this.editNotesData.observacions = nota;
    this.editNotesData.taula = taula;
    this.editNotesData.data = data_nota;
    this.editNotesData.nota_e = nota_e;    
    let dialogFactRef=this.dialog.open(DialogNotes, {disableClose: true, height: '590px', width: '1200px', data: {nota: this.editNotesData, user: this.userInfo}})
   
    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editNotesData = results;
      this.addOrUpdate();
    });
  }

  public addOrUpdate(): void {
    this.showAsyncProgress = true;
    this.notesService.updateNota(this.editNotesData)
      .subscribe(updatedNota => {console.log("S'han desat les dades");
        this.requestRowsToParent();
        this.showAsyncProgress = false;});
  }

  public editDedicacio(codi, tipus): void {
    this.editDedicacionsData = Object.assign(this.DedicacionsModel);
    this.editDedicacionsData.codi = codi;
    this.editDedicacionsData.tipus = tipus;
    let dialogFactRef=this.dialog.open(DialogDedicats, {disableClose: true, height: '590px', width: '1200px', data: this.editDedicacionsData })
  
    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editDedicacionsData = results;
    });
  }

  public editOportunitat(oportunitat: IFROportunitats): void {
    this.editOportunitatsData = Object.assign(oportunitat);
    let dialogFactRef=this.dialog.open(DialogOportunitats, {
        disableClose: true, height: '790px', width: '1200px',
        data: this.editOportunitatsData
    });

    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editOportunitatsData = results;
      this.addOrUpdateOp();
    });
  }

  public addOrUpdateOp(): void {
    this.showAsyncProgress = true;
    this.oportunitatsService.updateOportunitats(<number> this.editOportunitatsData.id, this.editOportunitatsData)
        .subscribe(updatedClientSoci => {console.log("S'han desat les dades");this.showAsyncProgress = false;
    });
  }

  public editInvoiceList(codi): void {
   let dialogFactListRef=this.dialog.open(DialogManageInvoiceComponent,{disableClose:true,data:codi})
   dialogFactListRef.afterClosed().subscribe(results => { if(!results)return; });
  }

  public navigateToProject(codi) {this.router.navigate(['project', codi]);}
  public navigateToProposal(codi){this.router.navigate(['proposal', codi]);}
  public navigateToProposalPe(codi){this.router.navigate(['proposalpe', codi]);}
  public navigateToCalendar(op){if(op == 0)this.router.navigate(['projects/hours',{}]);else this.router.navigate(['propostes/hours',{}]);};

  public notesFilters: Array<any>
  public ordreCamps: Array<any>

  constructor(public translate: TranslateService, public languageService: LanguageService, public striphtml:StripHtmlPipe, public tokenStorage: TokenStorageService, private oportunitatsService: OportunitatsService, private notesService: NotesService, private dedicatsService: DedicatsService, public dialog:MatDialog, public listNotesService: ListNotesService, private route: ActivatedRoute, private router: Router) { 
    this.userInfo = this.tokenStorage.getUser();
    this.rol = this.tokenStorage.getRol();
    let d =new Date();
    this.currentDate = d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + (d.getDate() + 1)).slice(-2)
  }
  
  ngOnInit() {
    this.ordreCamps = [];

    this.notesFilters = [
    {
      inputs: [
        {
          name: 'text',
          type: 'text',
          values: [
            {
              text: this.translate.instant('notes.filtrar.tecnic'),
              name: 'name',
              autocomplete: 'tecnicMcrit',
              value: this.listNotesService.getSearchValues('name')
            }
          ]
        }
      ]
    },
    {
      inputs: [
        {
          name: 'coordinador',
          type: 'checkbox',
          values: [
            {
              text: this.translate.instant('projectsList.coordinadorFiltre'),
              name: 'stateCoord',
              value: false
            }
          ]
        }
      ]
    }
  ];
  
  this.computeActiveFilters({});
 
  history.pushState(null,  document.title, location.href);

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });
  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  public dedicacionsMes(){ 
    let dialogFactRef = this.dialog.open(DialogDedicatsMes,{disableClose: true, width: '90%', height: '600px', data: {id: this.userInfo.id, nom: this.userInfo.name}});
    dialogFactRef.afterClosed().subscribe(results => {});
  }
  public curriculum(){ this.dialog.open(ManageCurriculumComponent,{disableClose: true, width: '800px', height: '500px', data: {id: this.userInfo.id, nom: this.userInfo.name}}); }
  public calendari(){ this.dialog.open(ManageCalendariComponent,{disableClose: true, width: '800px', height: '500px', data: {id: this.userInfo.id, nom: this.userInfo.name}}); }
  public curriculumV(){window.open("https://datastudio.google.com/s/uMC1oQ7-FNI?filter=personal_curriculum/id_personal eq '"+this.userInfo.id+"'", "_blank");}

}
